export const FillingIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="11" cy="11" r="10.5" fill="#F8F8F8" stroke="#2378C8" />
    <circle cx="11" cy="11" r="4.5" fill="#2378C8" stroke="#2378C8" />
  </svg>
);
